var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrReader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 246,
    viewBox: "0 0 244 246",
    fill: "none",
    stroke: "#FFCC3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.088 3.13086H39.0434C24.0445 3.13086 16.5451 3.13086 11.2878 6.95052C9.58986 8.18411 8.09671 9.67726 6.86312 11.3752C3.04346 16.6325 3.04346 24.1319 3.04346 39.1308V44.1754",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.553 44.1754L240.553 39.1309C240.553 24.1319 240.553 16.6325 236.733 11.3752C235.499 9.67726 234.006 8.18411 232.308 6.95052C227.051 3.13086 219.552 3.13086 204.553 3.13086L199.508 3.13086",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.508 242.858L204.553 242.858C219.552 242.858 227.051 242.858 232.308 239.039C234.006 237.805 235.499 236.312 236.733 234.614C240.553 229.357 240.553 221.857 240.553 206.858L240.553 201.814",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04346 201.814L3.04346 206.858C3.04346 221.857 3.04346 229.357 6.86312 234.614C8.09671 236.312 9.58986 237.805 11.2878 239.039C16.5451 242.858 24.0445 242.858 39.0434 242.858L44.088 242.858",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrReader);
export default __webpack_public_path__ + "static/media/qr_reader.9622f8ba.svg";
export { ForwardRef as ReactComponent };